import Text from '@/storybook/components/Text/Text';
import OutlinedCaretDownIcon from '@/storybook/icons/OutlinedCaretDownIcon';
import classNames from 'classnames';
import { FC } from 'react';
import styles from './ListHeader.module.css';
import { LIST_HEADERS_TEST_IDS } from './testIds';

interface ListHeaderProps {
  'category': string;
  'isNoCategory'?: boolean;
  'hideDivider'?: boolean;
  'collapsible'?: boolean;
  'isCollapsed'?: boolean;
  'isSelected'?: boolean;
  'alignCaretWithLabels'?: boolean;
  'onToggle'?: VoidFunction;
  'className'?: string;
  'data-testid'?: string;
}

const ListHeader: FC<ListHeaderProps> = ({
  category,
  isNoCategory,
  hideDivider,
  collapsible = false,
  isCollapsed = false,
  isSelected = false,
  alignCaretWithLabels = false,
  onToggle,
  className,
  'data-testid': testId = LIST_HEADERS_TEST_IDS.header(category, isNoCategory),
}) => {
  const headerClassName = classNames(
    styles.listHeader,
    { [styles.noDivider]: hideDivider, [styles.collapsible]: collapsible, [styles.selected]: isSelected },
    className,
  );

  if (!collapsible) {
    return (
      <li className={headerClassName} data-testid={testId}>
        {category}
      </li>
    );
  }

  return (
    <li className={headerClassName} data-testid={testId}>
      {/* DS Button exemption: its centred, nowrap, fixed-height layout can't host this full-width row. */}
      <button
        type="button"
        className={classNames(styles.toggle, { [styles.alignCaretWithLabels]: alignCaretWithLabels })}
        aria-expanded={!isCollapsed}
        onClick={onToggle}
        data-testid={LIST_HEADERS_TEST_IDS.toggle(testId)}
      >
        <OutlinedCaretDownIcon
          className={classNames(styles.chevron, { [styles.chevronExpanded]: !isCollapsed })}
          aria-hidden="true"
          data-testid={LIST_HEADERS_TEST_IDS.chevron(testId)}
        />
        <Text as="span" className={styles.label}>
          {category}
        </Text>
      </button>
    </li>
  );
};

export default ListHeader;
